import dataFlags from "../data/bait-to-plate/data-flags-combined.json";
import dataVessels from "../data/bait-to-plate/data-vessels.json";
import dataProcessorsWithFlags from "../data/bait-to-plate/data-processors-with-flags.json";
import dataImportersWithFlags from "../data/bait-to-plate/data-importers-with-flags.json";
import dataBuyersWithFlags from "../data/bait-to-plate/data-buyers-with-flags.json";


function getBaitToPlateSupplyChain() {
/*
const processorGetAllLinkedFlags = (processor) => {

  const flags = [];
  const linkedVessels = dataVessels.filter(vessel => vessel.raw.processors_list.includes(processor.slug));
  
  
  flags.vessel_flags = linkedVessels.reduce((acc, vessel) => [...acc, ...vessel.flags], [])
  .filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t.trim() === obj.trim()
    ));
  }).sort(function (a, b) {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    })

    return flags;
}

const importerGetAllLinkedFlags = (importer) => {
  const flags = [];
  const processors = dataProcessorsWithFlags.filter(processor => processor.importers.includes(importer.slug));
  
  const vessels = dataVessels.filter(vessel => vessel.raw.processors_list.filter(processor => processors.map(processor => processor.slug).includes(processor)).length > 0);
  flags.vessel_flags = vessels.reduce((acc, vessel) => [...acc, ...vessel.flags], [])
    .sort(function (a, b) {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    })
    .filter((obj, index, self) => {
      return index === self.findIndex((t) => (
        t.trim() === obj.trim()
      ));
    });
    

  flags.processor_flags = processors.reduce((acc, processor) => [...acc, ...processor?.flags], []).sort(function (a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  })
  .filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t.trim() === obj.trim()
    ));
  });
  return flags;
}

const buyerGetAllLinkedFlags = (buyer) => {
  const flags = [];
  const importersWithFlags = dataImportersWithFlags;
  const vessel_flags = [];
  const processor_flags = [];
  const importers = importersWithFlags.filter(item => item.buyers.find(buyerItem => buyerItem.slug === buyer.slug)).map((importer, index) => {

    const processors = dataProcessorsWithFlags.filter(processor => processor.importers.includes(importer.slug) && buyer.processors.includes(processor.slug));

    processors.map(processor => {
      const vesselFlags = dataVessels.filter(vessel => vessel.raw.processors_list.includes(processor.slug)).reduce((acc, vessel) => [...acc, ...vessel.flags], []);
      vessel_flags.push(...vesselFlags);
    });

    const processorFlags = processors.reduce((acc, processor) => [...acc, ...processor?.flags], []);
    processor_flags.push(...processorFlags);

    return importer;

  });
  flags.vessel_flags = vessel_flags.sort(function (a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  })
  .filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t.trim() === obj.trim()
    ));
  });
  flags.processor_flags = processor_flags.sort(function (a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  })
  .filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t.trim() === obj.trim()
    ));
  });

  return flags;
}
*/

const hasUyghurLaborFlag = (flags) => {
  return flags?.includes("uyghur-labor");
}
const hasNorthKoreanLaborFlag = (flags) => {
  return flags?.includes("north-korean-labor");
}

const hasEnvironmentalFlag = (flags) => {
  const environmentalFlagsSlugs = dataFlags.filter(flag => flag.is_environmental_concern).map((flag, index) => flag.slug);
  return flags?.filter(flag => environmentalFlagsSlugs.includes(flag))?.length > 0;
}
const hasHumanRightsFlag = (flags) => {
  const humanRightsFlagsSlugs = dataFlags.filter(flag => flag.is_human_rights_concern).map((flag, index) => flag.slug);
  return flags?.filter(flag => humanRightsFlagsSlugs.includes(flag))?.length > 0;
}
/*
const dataProcessorsWithFlags = dataProcessorsCombined.map((processor, index) => {
  const allLinkedFlags = processorGetAllLinkedFlags(processor);
  processor.vessel_flags = allLinkedFlags?.vessel_flags || [];
  return processor;
});
*/
/*
const dataImportersWithFlags = dataImportersCombined.map((importer, index) => {
  const allLinkedFlags = importerGetAllLinkedFlags(importer);
  importer.processor_flags = allLinkedFlags?.processor_flags || [];
  importer.vessel_flags = allLinkedFlags?.vessel_flags || [];
  
  return importer;
});
*/
/*
const allUniqueImporterBuyers = () => {
  const buyers = [];
  const importersWithFlags = dataImportersWithFlags;
  importersWithFlags.forEach(importer => {
    importer.buyers.forEach(buyer => {
      const buyerIndex = buyers.findIndex(item => item.slug === buyer.slug);
      if ( buyerIndex === -1 ) {
        buyers.push(buyer);
      }
      else {
        const buyerIndex = buyers.findIndex(item => item.slug === buyer.slug);
        buyers[buyerIndex].processors = [...buyers[buyerIndex].processors, ...buyer.processors];
      }
    });
  })
  return buyers
  .filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t.slug.trim() === obj.slug.trim()
    ));
  })
  .sort(function (a, b) {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    } else {
      return 0;
    }
  });
}
*/
/*
const dataBuyersWithFlags = allUniqueImporterBuyers().map((buyer) => {
  const allLinkedFlags = buyerGetAllLinkedFlags(buyer);
  buyer.processor_flags = allLinkedFlags?.processor_flags || [];
  buyer.vessel_flags = allLinkedFlags?.vessel_flags || [];
  return buyer;
});
*/
const TOOL_CATEGORIES = [
  {
    name: "Vessels",
    slug: "vessels",
    description: "Squid fishing vessels in China’s distant-water fleet",
    items: dataVessels,
    has_overview: true
  },
  {
    name: "Processors",
    slug: "processors",
    description: "Seafood processing plants in China",
    items: dataProcessorsWithFlags,
    has_overview: true
  },
  {
    name: "Importers",
    slug: "importers",
    description: "Companies receiving seafood from specific processing plants in China",
    items: dataImportersWithFlags,
    has_overview: true
  },
  {
    name: "Buyers",
    slug: "buyers",
    description: "Grocery Stores, Food Service Companies, Federal Agencies, and Restaurants",
    items: dataBuyersWithFlags,
    has_overview: true
  }
];

const supplyChainFullIndexItemsCombined = TOOL_CATEGORIES.map((category, index) => {
  return category.items.map((item, index) => {
    return {
      ...item,
    }
  });
}).flat().sort(function (a, b) {
  if (a.name < b.name) {
    return -1;
  } else if (a.name > b.name) {
    return 1;
  }
  else {
    return 0;
  }
});

  
  return supplyChainFullIndexItemsCombined;
}

export default getBaitToPlateSupplyChain;